import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Card, FormGroup, H3, H6, Icon, InputGroup, MenuItem, RangeSlider, TextArea } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { MultiSelect } from '@blueprintjs/select';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';
import { ProgressBar } from '@blueprintjs/core';




class CorpusCard extends React.PureComponent {

  constructor(props) {
    super(props);

    this.baseFilters = {
      collections: this.commonCollections,
      categories: [],  //  str
      authors: [],  //  str
      titles: [],  // str
      sourceLangs: [],  // str
      period: [],  // int
      otherAttr: "", // str
      otherAttrValues: [], // str *

    };

    this.state = {
      // note: each item is a string
      filters: this.baseFilters,
      corpus: this.props.corpus,
      stats: null,
      changed: false,
      allAttrs: [],
      otherAttr:"",
      useCommonCollection:true,
      textAreaValue:"",
      waitingRefresh:false,

    };
  }
  
  

  fetchAvailableFilters = () => {

    // REQUEST BODY
    // lang: str ("en", "fr", ...)
    // aligned_language: str ("en", "fr", ...)
    // collection: str ("phraseorom", ...)
    // categories: arrayOf(str)
    // authors: arrayOf(str)
    // titles: arrayOf(str)
    // source_languages: arrayOf(str)
    // year_min: int
    // year_max: int

    // RESPONSE BODY
    // - Below are filters
    // matches_categories
    // matches_authors
    // matches_titles
    // => list of value
    // matches_collection
    // aligned_language
    // source_languages
    // year_min
    // year_max
    // - Below are stats
    // nb_docs
    // nb_authors
    // nb_toks


    const { collection, categories, authors, titles, sourceLangs, period, otherAttrValues } = this.state.corpus;
    const [ minYear, maxYear ] = period;

    const data = {
      lang: this.props.lang,
      aligned_language: this.props.alignedLang,
      collection: collection,
      categories: categories,
      authors: authors,
      titles: titles,
      source_languages: sourceLangs,
      year_min: minYear,
      year_max: maxYear,
      other_attr:this.state.otherAttr,
      other_attr_values: otherAttrValues,
    };

    const endpoint = '/refresh_select.ajax.php';
    this.setState({waitingRefresh:true});
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
     
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        this.setState({waitingRefresh:false});
        return;
      }
      res.json().then((data) => {
        const newPeriod = [data.year_min, data.year_max];


        const newFilters = {
          collections: data.matches_collection,
          categories: data.matches_categories,
          authors: data.matches_authors,
          titles: data.matches_titles,
          sourceLangs: data.matches_source_languages,
          otherAttrValues: data.matches_other_attr_values,
          period: newPeriod,
        };

        const newStats = {
          nbDocs: data.nb_docs,
          nbAuthors: data.nb_authors,
          nbTokens: data.nb_toks
        };
        
        if (this.state.corpus.minYear) {
          const newCorpus = { ...this.state.corpus, nbToks: data.nb_toks, nbDocs: data.nb_docs };
          // nbToks and nbDocs must be updated for the parent component
          this.setState({ allAttrs: data.allAttrs, filters: newFilters, stats: newStats, corpus: newCorpus, waitingRefresh:false });
        } else {
          // at the first assignment, min and max boundaries are set
          const newCorpus = { ...this.state.corpus, 
            nbToks: data.nb_toks, 
            nbDocs: data.nb_docs, 
            minYear:data.year_min, 
            maxYear:data.year_max, 
            period:newPeriod 
          };
          // nbToks and nbDocs must be updated for the parent component
          this.setState({ allAttrs: data.allAttrs,filters: newFilters, stats: newStats, corpus: newCorpus, waitingRefresh:false });
        }
      })
      return this;
    })
    .catch(() => {
      console.log(`Network eror when trying to fetch ${endpoint}`);
      this.setState({waitingRefresh:false});
    })
    return this;
  }

  // Multiselect filters functions

  renderFilterElement = (filterElement, handleClick, modifiers, filterType) => {
    const filterItem = filterElement;
    var filterIcon='blank';
    if (this.state.corpus[filterType]) {
      filterIcon= this.state.corpus[filterType].includes(filterItem) ? 'tick' : 'blank';
    }
    return (
      <MenuItem
        key={filterItem}
        active={modifiers.active}
        text={filterItem}
        icon={filterIcon}
        onClick={handleClick}
        shouldDismissPopover={false}
      />
    )
  }

  filterElements = (query, filterElement) => {
    const filterItem = filterElement;
    const filterItemUpper = filterItem.toUpperCase();
    const queryUpper = query.toUpperCase();
    return filterItemUpper.includes(queryUpper);
  }

  addSelectedFilterToCorpus = (filterElement, filterType) => {
    const filterItem = filterElement;

    this.setState(prevState => {
      // update the correct filter (categories, authors or titles) of `corpus`
      const corpusFilterTypeValues = prevState['corpus'][filterType];
      let newCorpusFilterTypeValues;
      if (corpusFilterTypeValues.includes(filterItem)) {
        newCorpusFilterTypeValues = corpusFilterTypeValues.filter(el => el !== filterItem);
      } else {
        newCorpusFilterTypeValues = [...corpusFilterTypeValues, filterItem];
      }

      // reflect this change in the state
      const prevCorpus = prevState.corpus;
      const newCorpus = { prevCorpus, [filterType]: newCorpusFilterTypeValues };
      return { corpus: newCorpus, changed:filterType };
    });
  }

  removeSelectedFilterToCorpus = (filterLabel, filterType) => {
    this.setState(prevState => {
      const corpusFilterTypeValues = prevState.corpus[filterType];
      const newCorpusFilterTypeValues = corpusFilterTypeValues.filter(el => el !== filterLabel);
      const newCorpus = { ...prevState.corpus, [filterType]: newCorpusFilterTypeValues };
      return { corpus: newCorpus, changed:filterType };
    });
  }

  onChangeName = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    this.setState((prevState) => {
      const prevCorpus = prevState.corpus;
      const newCorpus = { ...prevCorpus, [name]: value };
      return { corpus: newCorpus };
    });
  }

  onFocusCategories = (e) => {
    e.preventDefault();
    if (this.state.changed && this.state.changed!=="categories") {
      // the current values are updated from the server
      this.fetchAvailableFilters();
      this.setState({changed:false});
    }
  }

  onFocusAuthors = (e) => {
    e.preventDefault();
    if (this.state.changed && this.state.changed!=="authors") {
      // the current values are updated from the server
      this.fetchAvailableFilters();
      this.setState({changed:false});
    }
  }

  onFocusTitles = (e) => {
    e.preventDefault();
    if (this.state.changed && this.state.changed!=="titles") {
      // the current values are updated from the server
      this.fetchAvailableFilters();
      this.setState({changed:false});
    }
  }

  onFocusSourceLangs = (e) => {
    e.preventDefault();
    if (this.state.changed && this.state.changed!=="sourceLangs") {
      // the current values are updated from the server
      this.fetchAvailableFilters();
      this.setState({changed:false});
    }
  }



  onChangeCommonCollection = (e) => {
    e.preventDefault();
    const {value} = e.target;
    
    // new strategy - reset when collection changes
    this.setState( 
      { filters: this.baseFilters, 
        stats: null,
        useCommonCollection:true, 
        corpus: { ...this.props.corpus, 'collection': value, 'name':this.state.corpus.name }}, 
        () => { 
          this.fetchAvailableFilters();
      });
  }

  onChangePrivateCollection = (e) => {
    e.preventDefault();
    const {value} = e.target;
    
    this.setState( 
      { filters: this.baseFilters, 
        stats: null,
        useCommonCollection:false, 
        corpus: { ...this.props.corpus, 'collection': value, 'name':this.state.corpus.name  }}, 
        () => { 
          this.fetchAvailableFilters();
      });
  }

  onChangeOtherAttr = (e) => {
    e.preventDefault();
    const {value} = e.target;
    
    this.setState({otherAttr:value}, this.fetchAvailableFilters );
    this.addSelectedFilterToCorpus(value, 'otherAttr');
  }


  updateRangeSlider = (value) => {
    this.setState(prevState => {
      const prevCorpus = prevState.corpus;
      const newCorpus = { ...prevCorpus, period: value };
      return { corpus: newCorpus };
    });
  }

  addValues = () => {
    const textAreaValue=this.state.textAreaValue;
    textAreaValue.split("\n").forEach( (element) => { 
      if  (this.state.filters.otherAttrValues.includes(element)) {
         this.addSelectedFilterToCorpus(element, 'otherAttrValues')
      }
    }) 
  }


  resetCorpus = () => {
    this.setState({
      corpus: this.props.corpus,
      filters: this.baseFilters,
      stats: null,
    });
  }

  // corpus is transmitted to the parent through
  // TODO : chain the process without setTimeout
  setCorpusReady = () => {
    //if (!this.state.corpus.name) { // assignation d'un nom par défaut : à revoir
    //   this.setState( { corpus: { name: "corpus_"+this.state.corpus.id}});
    //}
    this.fetchAvailableFilters().setState(
      prevState => ({ corpus: { ...prevState.corpus, ready: true} }),
      () => { 
        setTimeout(()=>{this.props.onCorpusReady(this.state.corpus)},1000);
      }
    );
  }

  render() {
    const { corpus, filters, stats, allAttrs } = this.state;
    const { t } = this.props;

    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    const corpusCardClasses = classNames(
      'margin-bottom-1-rem',
      'margin-right-05-rem',
      {'active-card': !corpus.ready},
      {'success-card': corpus.ready},
    );

    const commonCollectionValue=  (this.state.useCommonCollection === true) ? this.state.corpus.collection :"";
    const privateCollectionValue= (this.state.useCommonCollection === false) ? this.state.corpus.collection : "" ;
    
    // console.log("privateCollectionValue="+privateCollectionValue," commonCollectionValue=",commonCollectionValue);
    return(
      <Card elevation={2} className={corpusCardClasses}>

        <div className="flex flex-between">
          <H3 className="margin-bottom-1-5rem">{t('subCorpusParams')}</H3>
          <Icon icon={IconNames.CROSS} iconSize={Icon.SIZE_LARGE} onClick={() => this.props.onDeleteCorpus(corpus)} />
        </div>

        { this.state.waitingRefresh && 
          <ProgressBar />

        }

        <FormGroup label={t('subCorpusName')} labelFor={`name-${corpus.id}`} inline={true}>
          <InputGroup
            disabled={corpus.ready}
            id={`name-${corpus.id}`}
            name="name"
            value={corpus.name}
            onChange={this.onChangeName}
          />
        </FormGroup>

        <EnhancedSingleSelect
          disabled={corpus.ready}
          value={commonCollectionValue}
          hasDefault={true}
          hasSelectableDefault={true}
          label={t('collection')}
          name={"collection"}
          options={this.props.commonCollections}
          onChange={this.onChangeCommonCollection}
          popoverProps={{ minimal: true }}
        />

        <EnhancedSingleSelect
          disabled={corpus.ready}
          value={privateCollectionValue}
          hasDefault={true}
          hasSelectableDefault={true}
          label={t('privateCollections')}
          name={"privateCollections"}
          options={this.props.privateCollections}
          onChange={this.onChangePrivateCollection}
          popoverProps={{ minimal: true }}
        />

        <H6>{t('filters')}</H6>
        <div onFocus={this.onFocusCategories}>
          <FormGroup label={t('categories')} inline={true} >
            <MultiSelect
              items={filters.categories}
              itemRenderer={
                (filterElement, { handleClick, modifiers }) => {
                  return this.renderFilterElement(filterElement, handleClick, modifiers, 'categories');
                }
              }
              itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
              onItemSelect={(filterElement) => this.addSelectedFilterToCorpus(filterElement, 'categories')}
              selectedItems={corpus.categories}
              tagInputProps={{
                interactive: true,
                disabled: corpus.ready,
                onRemove: (filterLabel) => this.removeSelectedFilterToCorpus(filterLabel, 'categories'),
              }}
              // tagRenderer takes as input what selectedItems gives
              tagRenderer={filterLabel => filterLabel}
              noResults={<MenuItem disabled={true} text={t('noResult')} />}
              placeholder={t('filterByCategories')}
            />
          </FormGroup>
        </div>

        <div onFocus={this.onFocusAuthors}>
          <FormGroup label={t('authors')} inline={true}>
            <MultiSelect          
              items={filters.authors}
              itemRenderer={
                (filterElement, { handleClick, modifiers }) => (
                  this.renderFilterElement(filterElement, handleClick, modifiers, 'authors')
                )
              }
              itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
              onItemSelect={(filterElement) => this.addSelectedFilterToCorpus(filterElement, 'authors')}
              selectedItems={corpus.authors}
              tagInputProps={{
                interactive: true,
                disabled: corpus.ready,
                onRemove: (filterLabel) => this.removeSelectedFilterToCorpus(filterLabel, 'authors'),
              }}
              // tagRenderer takes as input what selectedItems gives
              tagRenderer={filterLabel => filterLabel}
              noResults={<MenuItem disabled={true} text={t('noResult')} />}
              placeholder={t('filterByAuthors')}
            />
          </FormGroup>
        </div>

        <div onFocus={this.onFocusTitles}>
          <FormGroup label={t('titles')} inline={true} >
            <MultiSelect
              items={filters.titles}
              itemRenderer={
                (filterElement, { handleClick, modifiers }) => (
                  this.renderFilterElement(filterElement, handleClick, modifiers, 'titles')
                )
              }
              itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
              onItemSelect={(filterElement) => this.addSelectedFilterToCorpus(filterElement, 'titles')}
              selectedItems={corpus.titles}
              tagInputProps={{
                interactive: true,
                disabled: corpus.ready,
                onRemove: (filterLabel) => this.removeSelectedFilterToCorpus(filterLabel, 'titles'),
              }}
              // tagRenderer takes as input what selectedItems gives
              tagRenderer={filterLabel => filterLabel}
              noResults={<MenuItem disabled={true} text={t('noResult')} />}
              placeholder={t('filterByTitles')}
            />
          </FormGroup>
        </div>

        <div onFocus={this.onFocusSourceLangs}>
          <FormGroup label={t('sourceLangs')} inline={true}>
            <MultiSelect
              items={filters.sourceLangs}
              itemRenderer={
                (filterItem, { handleClick, modifiers }) => (
                  this.renderFilterElement(filterItem, handleClick, modifiers, 'sourceLangs')
                )
              }
              itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
              onItemSelect={(filterElement) => this.addSelectedFilterToCorpus(filterElement, 'sourceLangs')}
              selectedItems={corpus.sourceLangs}
              tagInputProps={{
                interactive: true,
                disabled: corpus.ready,
                onRemove: (filterLabel) => this.removeSelectedFilterToCorpus(filterLabel, 'sourceLangs'),
              }}
              // tagRenderer takes as input what selectedItems gives
              tagRenderer={filterLabel => filterLabel}
              noResults={<MenuItem disabled={true} text={t('noResult')} />}
              placeholder={t('filterBySourceLangs')}
            />
          </FormGroup>
        </div>

        <div onFocus={this.onFocusSourceLangs}>
          <FormGroup label={t('otherAttr')} inline={true}>
            <EnhancedSingleSelect
              disabled={corpus.ready}
              value={this.state.otherAttr}
              hasDefault={true}
              hasSelectableDefault={true}
              name={'otherAttr'}
              options={allAttrs}
              onChange={this.onChangeOtherAttr}
              popoverProps={{ minimal: true }}
            />
          </FormGroup>
          <FormGroup label={t('selectAValueForOtherAttr')} inline={true}>
            <MultiSelect
              items={filters.otherAttrValues}
              itemRenderer={
                (filterItem, { handleClick, modifiers }) => (
                  this.renderFilterElement(filterItem, handleClick, modifiers, 'otherAttrValues')
                )
              }
              itemPredicate={(query, filterElement) => this.filterElements(query, filterElement)}
              onItemSelect={(filterElement) => this.addSelectedFilterToCorpus(filterElement, 'otherAttrValues')}
              selectedItems={corpus.otherAttrValues}
              tagInputProps={{
                interactive: true,
                disabled: corpus.ready,
                onRemove: (filterLabel) => this.removeSelectedFilterToCorpus(filterLabel, 'otherAttrValues'),
              }}
              // tagRenderer takes as input what selectedItems gives
              tagRenderer={filterLabel => filterLabel}
              noResults={<MenuItem disabled={true} text={t('noResult')} />}
            />
            {t('orCopyPasteHereTheValuesInTheTextArea')}
            <TextArea
              source='otherAttrValues'
              placeholder={t('filterBySourceLangs')}
              style={{'height': '100px', 'width': '600px'}}
              onChange={(e)=>this.setState({textAreaValue:e.target.value})}
            />
            <Button onClick={this.addValues}>{t('addTheValues')}</Button>
          </FormGroup>
        </div>

        {(corpus.collection && corpus.minYear && corpus.maxYear) && 
          <RangeSlider
            disabled={corpus.ready}
            min={corpus.minYear}
            max={corpus.maxYear}
            labelStepSize={10}
            onChange={this.updateRangeSlider}
            onRelease={this.fetchAvailableFilters}
            value={corpus.period}
          />
        }

        {stats &&
          <>
            <H6>{t('recapInfo')}</H6> <Button text={t('update')} onClick={this.fetchAvailableFilters} />
            <ul>
              <li>{t('docNumberColon')} {stats.nbDocs}</li>
              <li>{t('authorsNumColon')} {stats.nbAuthors}</li>
              <li>{t('tokenNumberColon')} {Intl.NumberFormat(langFormat, { useGrouping: true }).format(stats.nbTokens)}</li>
            </ul>
          </>
        }

        {!corpus.ready &&
          <>
            <Button text={t('reset')} onClick={this.resetCorpus} />
            <Button text={t('corpusReady')} onClick={this.setCorpusReady} />
          </>
        }

      </Card>
    );
  }
}

CorpusCard.propTypes = {
  commonCollections: PropTypes.array,
  privateCollections : PropTypes.array,
  lang: PropTypes.string,
  alignedLang: PropTypes.string,
  corpus: PropTypes.shape({
    id: PropTypes.number,
    ready: PropTypes.bool,
    name: PropTypes.string,
    collection: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    authors: PropTypes.arrayOf(PropTypes.string),
    titles: PropTypes.arrayOf(PropTypes.string),
    sourceLangs: PropTypes.arrayOf(PropTypes.string),
    period: PropTypes.arrayOf(PropTypes.number),
  }),
  onCorpusReady: PropTypes.func,
  onDeleteCorpus: PropTypes.func,
};

export default withTranslation()(CorpusCard);
